export var webshop_order_create = {
  data() {
    return {
      rules: {
        first_name: [v => !!v || this.$t("rules.field_required")],
        last_name: [v => !!v || this.$t("rules.field_required")],
        email_address: [
          v => !!v || this.$t("rules.field_required"),
          v => /.+@.+\..+/.test(v) || this.$t("rules.email_not_valid")
        ]
      },
      validatingLicensePlateSuccessMessage: "",
      validatingLicensePlateErrorMessage: "",
      validatingLicensePlateLoadingMessage: "",
      validatingLicensePlateLoadingIcon: null,
      validatingLicensePlateLoader: false,
      licensePlateValid: true
    };
  },
  methods: {
    licensePlateRule(requirement) {
      if (requirement === "required") {
        return [v => !!v || this.$t("rules.field_required")];
      }
      return [];
    },
    validateLicensePlate(license_plate) {
      this.licensePlateValid = false;
      this.validatingLicensePlateErrorMessage = "";
      this.validatingLicensePlateSuccessMessage = "";
      this.validatingLicensePlateLoadingIcon = null;
      if (
        license_plate === null ||
        license_plate === undefined ||
        license_plate.length === 0
      ) {
        this.validatingLicensePlateLoadingMessage = "";
        this.licensePlateValid = true;
        return;
      }
      this.validatingLicensePlateLoader = true;
      this.validatingLicensePlateLoadingMessage = this.$t(
        "message.controlling_license_plate"
      );
      this.$store
        .dispatch("webshop/validateLicensePlate", {
          license_plate: license_plate
        })
        .then(() => {
          this.licensePlateValid = true;
          this.validatingLicensePlateLoader = false;
          this.validatingLicensePlateLoadingMessage = "";
          this.validatingLicensePlateLoadingIcon = "mdi-check";
          this.validatingLicensePlateSuccessMessage = this.$t(
            "success.license_plate_valid"
          );
        })
        .catch(error => {
          switch (error.response.status) {
            case 429:
              this.validatingLicensePlateLoader = false;
              this.validatingLicensePlateErrorMessage = this.$t(
                "error.too_many_requests"
              );
              break;
            case 400:
              this.validatingLicensePlateLoadingIcon = "mdi-cancel";
              this.validatingLicensePlateLoader = false;
              this.validatingLicensePlateErrorMessage = this.$t(
                "error.invalid_license_plate"
              );
              break;
          }
        });
    }
  }
};
